<template>
    <div class="row">
        <div class="col-12">
            <div class="alert alert-primary mb-0 mx-1 mt-1">
                <div class="alert-body">
                    Kasa Kodu: {{ $safe(value,'VaultCode') }}
                </div>
            </div>
        </div>
        <template v-for="(d,i) in ($safe(value,'Months') || [])">
            <div class="col-12 mt-1">
                <div class="table-responsive mb-0">
                    <table class="table table-sm table-bordered bordered-header">
                        <thead>
                            <tr>
                                <th colspan="12">{{ $safe(d,'Year') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td v-for="(m,ii) in months" :key="ii">
                                    <b-form-checkbox v-model="d[m.key]">{{ m.name }}</b-form-checkbox>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue';
export default {
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    },
    data(){
        return {
            months:[
                {name:'Ocak',key:'Ocak'},
                {name:'Şubat',key:'Subat'},
                {name:'Mart',key:'Mart'},
                {name:'Nisan',key:'Nisan'},
                {name:'Mayıs',key:'Mayis'},
                {name:'Haziran',key:'Haziran'},
                {name:'Temmuz',key:'Temmuz'},
                {name:'Ağustos',key:'Agustos'},
                {name:'Eylül',key:'Eylul'},
                {name:'Ekim',key:'Ekim'},
                {name:'Kasım',key:'Kasim'},
                {name:'Aralık',key:'Aralik'},
            ]
        }
    }
}
</script>